<div class="modal-header border-0 py-2">
	<h5 class="modal-title modal-text-alert">{{title | translate}}</h5>
	<i class="bi bi-x bi-lg fs-4 float-end ms-auto pointer" (click)="modal.close()"></i>
</div>
<div class="modal-body pt-2 pb-4 modal-text-dark">
	<p class="mb-0 text-break" [innerHTML]="message | translate"></p>
	<!-- <div class="confirm-delete">
		<p [innerHTML]="message"></p>
		@if (erroreHttp) {
			<div class="text-start">
				Url: {{erroreHttp.url}}
				<br />
				{{'CodiceErrore' | translate}}: {{erroreHttp.status}} - {{erroreHttp.statusText}}
				@if (erroreHttp.error) {
					<pre [innerHTML]="erroreHttp.error | json"></pre>
				}
			</div>
		}
		<div class="d-flex w-100 mt-4 justify-content-center">
			<button type="button" class="btn btn-outline-primary" (click)="modal.close()">{{close | translate}}</button>
			<a [href]="hrefInvioMail">
				<button type="button" class="btn btn-primary ms-3" (click)="modal.close()" translate>InviaSegnalazione</button>
			</a>
		</div>
	</div> -->
</div>
<!-- <div class="modal-footer border-0 d-flex align-items-end mt-2">
	<button class="btn text-uppercase" (click)="modal.close()">Indietro</button>
</div> -->

